import { render, staticRenderFns } from "./ElementsTree.vue?vue&type=template&id=63c44e91&scoped=true&"
import script from "./ElementsTree.vue?vue&type=script&lang=js&"
export * from "./ElementsTree.vue?vue&type=script&lang=js&"
import style0 from "./ElementsTree.vue?vue&type=style&index=0&id=63c44e91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c44e91",
  null
  
)

export default component.exports